'use client';

import { useEffect, useRef } from 'react';
import { useCurrencyStore } from '@/store';
import { getCurrencyConfig } from '@/actions/currency';

export default function CurrencyInitializer() {
    const ranRef = useRef(false);

    useEffect(() => {
        if (ranRef.current) return;
        ranRef.current = true;
        // Restore the visitor's persisted currency first (instant, last-known
        // rates), then refresh the currency list and rates in the background.
        useCurrencyStore.persist.rehydrate();
        getCurrencyConfig()
            .then((config) => useCurrencyStore.getState().applyConfig(config))
            .catch(() => {
                // Offline / transient failure: keep the persisted (or USD
                // fallback) config — never block rendering on currency data.
            });
    }, []);

    return null;
}
